import styled from 'styled-components';

export const ContainerCustom = styled.div`
    padding:0px;
    width: 100%;
    position:absolute;
    top:0px;
    z-index:5;
`;